import {
	Box,
	Pagination,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../assets/styles/themes/tokens';
import InvoiceTableEmptyRow from './InvoiceTableEmptyRow';
import InvoiceTableRow from './InvoiceTableRow';
import { columns } from './incoiceTableColumns';

interface InvoiceHistoryTableProps {
	invoiceHistory: any;
	onClickDownload: (id: string) => void;
	pageSize: number;
	serverError: Error | null;
}

const InvoiceHistoryTable = ({
	invoiceHistory,
	onClickDownload,
	pageSize = 20,
	serverError,
}: InvoiceHistoryTableProps) => {
	const { t } = useTranslation();
	const [currentPage, setCurrentPage] = useState(1);

	const invoices = invoiceHistory?.invoices;
	const countInvoices = invoices?.length || 0;

	const paginatedInvoices =
		invoices?.slice((currentPage - 1) * pageSize, currentPage * pageSize) || [];

	const onPageIndexChange = (event: any, page: number) => {
		if (event && page !== currentPage) {
			setCurrentPage(page);
		}
	};

	return (
		<Box>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							{columns.map((column) => (
								<TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
									{t(column.label)}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{paginatedInvoices?.length > 0 ? (
							paginatedInvoices.map((invoice: any, index: number) => (
								// biome-ignore lint/suspicious/noArrayIndexKey: index keys are pre-existing; switching the key source changes reconciliation behavior
								<InvoiceTableRow key={index} invoice={invoice} onClickDownload={onClickDownload} />
							))
						) : (
							<InvoiceTableEmptyRow colSpan={columns.length} />
						)}
						{serverError && (
							<TableRow>
								<TableCell colSpan={columns.length}>
									<Typography sx={{ padding: spaces.md }} color={palette.error.main}>
										{t('Ups, something went wrong')}
									</Typography>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
					{countInvoices > pageSize && (
						<TableFooter>
							<TableRow>
								<TableCell colSpan={5} align="center">
									<Pagination
										count={Math.ceil(countInvoices / pageSize)}
										page={currentPage}
										onChange={onPageIndexChange}
										color="primary"
										size="large"
										showFirstButton
										showLastButton
									/>
								</TableCell>
							</TableRow>
						</TableFooter>
					)}
				</Table>
			</TableContainer>
		</Box>
	);
};

export default InvoiceHistoryTable;
